import React from 'react';
import PropTypes from 'prop-types';
import { ButtonText, ButtonInner, ButtonWrapper, customStyle } from './styled';

const Button = ({
  bkgColor,
  bold,
  border,
  color,
  dataCy,
  fontSize,
  height,
  isDesktop,
  marginButton,
  marginText,
  noMaxWidth,
  noSpacing,
  onClick,
  padding,
  title,
  width
}) => (
  <ButtonWrapper isDesktop={isDesktop} onClick={onClick} margin={marginButton} noMaxWidth={noMaxWidth}>
    <ButtonInner
      data-cy={dataCy}
      isDesktop={isDesktop}
      bkgColor={bkgColor}
      color={color}
      border={border}
      padding={padding}
      style={customStyle(width, height)}
    >
      <ButtonText marginText={marginText} noSpacing={noSpacing} bold={bold} fontSize={fontSize}>
        {title}
      </ButtonText>
    </ButtonInner>
  </ButtonWrapper>
);

Button.propTypes = {
  bkgColor: PropTypes.string,
  bold: PropTypes.bool,
  border: PropTypes.string,
  color: PropTypes.string,
  dataCy: PropTypes.string,
  fontSize: PropTypes.number,
  height: PropTypes.number,
  isDesktop: PropTypes.bool,
  marginButton: PropTypes.string,
  marginText: PropTypes.string,
  noMaxWidth: PropTypes.bool,
  noSpacing: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  padding: PropTypes.string,
  title: PropTypes.string.isRequired,
  width: PropTypes.number
};

export default Button;
